import { render } from "./TradeUpdate.vue?vue&type=template&id=313bfdc0&scoped=true"
import script from "./TradeUpdate.vue?vue&type=script&lang=js"
export * from "./TradeUpdate.vue?vue&type=script&lang=js"

import "./TradeUpdate.vue?vue&type=style&index=0&id=313bfdc0&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313bfdc0"]])

export default __exports__